export default payload => ({
	type: 'LOAD_DICTIONARY',
	payload
})
